import {
  CollaborativeDocumentFragment,
  CollaborativeDocumentQuery,
  CollaborativeDocumentQueryVariables,
  useCollaborativeDocumentQuery,
  withStandardGetHook,
} from '@spotify/confidence-graphql';

const useCollaborativeDocumentImpl = withStandardGetHook<
  CollaborativeDocumentQuery,
  CollaborativeDocumentFragment,
  'collaborativeDocument',
  CollaborativeDocumentQueryVariables
>(useCollaborativeDocumentQuery, 'collaborativeDocument', {
  fetchPolicy: 'cache-and-network',
});

type CollaborativeDocumentOptions = Parameters<
  typeof useCollaborativeDocumentImpl
>[0];

export const useCollaborativeDocument = (
  options: CollaborativeDocumentOptions,
): ReturnType<typeof useCollaborativeDocumentImpl> =>
  useCollaborativeDocumentImpl(options);
